module.exports = __webpack_public_path__ + "static/media/top-4.34f4fe67.png";